/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperLayout = {
    /**
     * Handle offcanvas
     */
    handleOffCanvas() {
        const storeOffCanvas = Alpine.store('offcanvas')
        if (!this.isMobile && storeOffCanvas.activeOffCanvas === 'facets') {
            storeOffCanvas.activeOffCanvas = false
        }
    },
    /**
     * Remove skeleton loader
     */
    removeSkeleton() {
        const skeleton = document.getElementById('product-list-skeleton')
        if (skeleton) {
            skeleton.remove()
        }
    }
}

export default liveSearchHelperLayout
